<template>
    <div class="form-dynamic-wrapper mb-2">
        <b-form-group :label="label" :label-class="isRemove ? 'foto-label-with-remove' : ''">
        <b-button v-if="isShowFoto" @click="$emit('openPreview',fotoUrl)" name="anggotaUpdateBtn" variant="pgiBtn" class="mb-2">
            Lihat Foto Sebelumnya
          </b-button>
            <b-row>
                <b-col lg="6" md="6">
                    <div class="foto-input-wrapper">
                        <div class="foto-preview-wrapper">
                            <div class="foto-content-wrapper" v-if="fotoPendukung.activeFotoPendukungBase64 != null">
                                <video v-if="fotoPendukung.isVideo" :src="fotoPendukung.activeFotoPendukungBase64" muted preload="metadata" style="max-width: 100%; max-height: 100%;"></video>
                                <img v-else :src="fotoPendukung.activeFotoPendukungBase64" alt="Foto Pendukung">
                                <div class="foto-view-wrapper">
                                    <b-button @click="openModalPreview()">View</b-button>
                                </div>
                            </div>
                            <h6 v-else class="text-blue">{{ videoOnly ? "No Video" : "No Photo" }}</h6>
                        </div>
                        <div class="foto-action-wrapper flex-wrap">
                            <div class="action-browse-wrapper">
                                <b-form-file
                                    v-model="fotoPendukung.fotoBarangPendukung" name="fotoBarangPendukung"
                                    :state="Boolean(fotoPendukung.fotoBarangPendukung)"
                                    :placeholder="fotoPendukung.fotoBarangPendukungPlaceholder"
                                    drop-placeholder="Drop file here..."
                                    :accept="videoOnly ? 'video/*' : '.jpg, .png, .jpeg'"
                                    @input="browseFile()"
                                    :class="customClass"
                                    >
                                </b-form-file>
                                <b-button variant="cancelBtn">
                                    <i class="fa fa-upload mr-2"></i>
                                    Browse
                                </b-button>
                            </div>
                            <div class="action-camera-wrapper cameraSmallWrapper" v-if="!isNotShowCam && !videoOnly">
                                <b-button variant="cancelBtn" class="foto-cam-btn" name="fotoViaCameraBtn" @click="ambilFotoBarang()">
                                    <i class="fa fa-camera mr-2"></i>
                                    Camera 
                                </b-button>
                            </div>
                            <!-- DESKTOP -->

                            <!-- MOBILE -->
                            <div class="action-camera-wrapper cameraMobileWrapper">
                                <b-button variant="cancelBtn" class="foto-cam-btn" @click="onCamera()">
                                    <i class="fa mr-2" :class="videoOnly ? 'fa-video-camera' : 'fa-camera'"></i>
                                    Camera 
                                </b-button>

                                <input
                                    style="display: none;"
                                    ref="cameraInput"
                                    type="file" 
                                    :accept="videoOnly ? 'video/*' : 'image/*'"
                                    capture="environment" 
                                    @change="handleKameraMobile"
                                />
                            </div>
                            <!-- MOBILE -->

                            <div class="action-reset-wrapper" v-if="fotoPendukung.urlFotoBarangPendukung != null && fotoPendukung.activeFotoPendukungBase64 != $baseFilePath + fotoPendukung.urlFotoBarangPendukung">
                                <b-button variant="cancelBtn" @click="resetFoto()">
                                    <i class="fa fa-undo mr-2"></i>
                                    Reset
                                </b-button>
                            </div>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </b-form-group>
        
        <div class="form-dynamic-deleteWrapper" v-if="isRemove">
            <b-button variant="dynamicDeleteBtn" name="deleteFotoPendukung" @click="$emit('remove', fotoPendukung.index)" :disabled="length == minLength"><i class="fa fa-times"></i></b-button>
        </div>
    </div>
</template>

<script>

export default {
    name: 'foto-pendukung',
    props: {
        fotoPendukung: { type: Object, required: true },
        length: { type: Number, required: true },
        minLength: { type: Number, required: true },
        lat:{type: Number},
        long:{type: Number},
        gadai:{type: String},
        isRemove:{type: Boolean},
        isShowFoto:{type: Boolean},
        fotoUrl :{type:String},
        isNotShowCam: { type: Boolean },
        customClass: { type: String, default: '' },
        label: { type: String, default: 'Foto Pendukung' },
        videoOnly: { type: Boolean, default: false },
    },
    methods: {
        ambilFotoBarang(){
            this.$emit("showModalCam", this.fotoPendukung.index)
        },

        openModalPreview(){
            this.$emit("showModalPreview", this.fotoPendukung.index)
        },

        browseFile(){
            const file = this.fotoPendukung.fotoBarangPendukung
            const previousUrl = this.fotoPendukung.activeFotoPendukungBase64
            if (file != null && previousUrl && previousUrl.startsWith('blob:')) URL.revokeObjectURL(previousUrl)
            const isVideo = this.videoOnly && file != null && (file.type || '').startsWith('video/')
            this.$set(this.fotoPendukung, 'isVideo', isVideo)
            if (isVideo) {
                this.$set(this.fotoPendukung, 'activeFotoPendukungBase64', URL.createObjectURL(file))
                this.$set(this.fotoPendukung, 'checkFotoBarangPendukung', true)
                return
            }
            //letakin ke null masing2
            if(this.gadai == "true"){
                this.toBase64(this.fotoPendukung.fotoBarangPendukung).then(async base64 => {
                    var newResult = await this.$helper.resizeImage(base64)

                    this.$set(this.fotoPendukung, 'fotoBarangPendukungBase64', newResult);
                    this.$set(this.fotoPendukung, 'activeFotoPendukungBase64', newResult);
                    this.$set(this.fotoPendukung, 'checkFotoBarangPendukung', true);
                })
                .catch(error => {
                    if(this.fotoPendukung.fotoBarangPendukung != null){
                        this.$helper.toastErr(this, "Gagal memproses gambar, silahkan coba kembali!")
                    }
                })
            }
            else{
                this.$store.dispatch('loading/show')
                this.toBase64(this.fotoPendukung.fotoBarangPendukung).then(async base64 => {
                    var newResult = await this.$helper.resizeImage(base64)

                    let formattedDate = this.$helper.formatTanggalDMY()
                    let waktu = this.$helper.waktu24()

                    let img = new Image()
                    await new Promise((resolve, reject) => {
                        img.onload = resolve
                        img.onerror = reject
                        img.src = newResult
                    })

                    let canvas = document.createElement('canvas')
                    let ctx = canvas.getContext('2d')
                    canvas.setAttribute("width", img.width);
                    canvas.setAttribute("height", img.height);

                    ctx.drawImage(img, 0, 0,)
                    ctx.font = "14pt Arial";
                    ctx.fillStyle = "#ffffff"; //<======= here
                    ctx.fillText(formattedDate + ' ' + waktu, 10, img.height - 40 ,);
                    ctx.strokeText(formattedDate + ' ' + waktu, 10, img.height - 40 ,);
                    ctx.fillText(this.lat + ' ' +this.long, 10, img.height - 10 ,);
                    ctx.strokeText(this.lat + ' ' +this.long, 10, img.height - 10 ,);

                    let newBase64Str = canvas.toDataURL('image/jpeg', 0.9)
                    this.$set(this.fotoPendukung, 'fotoBarangPendukungBase64', newBase64Str);
                    this.$set(this.fotoPendukung, 'activeFotoPendukungBase64', newBase64Str);
                    this.$set(this.fotoPendukung, 'checkFotoBarangPendukung', true);
                })
                .catch(error => {
                    if(this.fotoPendukung.fotoBarangPendukung != null){
                        this.$helper.toastErr(this, "Gagal memproses gambar, silahkan coba kembali!")
                    }
                })
                .finally(() => this.$store.dispatch('loading/hide'))
            }
        },

        toBase64(file) {

            return new Promise((resolve, reject) => {
                const reader = new FileReader()
                reader.readAsDataURL(file)
                reader.onload = () => resolve(reader.result)
                reader.onerror = error => reject(error)
            })

        },

        resetFoto(){
            const activeFotoPendukung64 = this.$baseFilePath + this.fotoPendukung.urlFotoBarangPendukung
            this.$set(this.fotoPendukung, 'activeFotoPendukungBase64', activeFotoPendukung64);
        },

        onCamera() {
            this.$refs.cameraInput.click();
        },

        handleKameraMobile(event) {
            const file = event.target.files[0];
            if (!file) return;

            this.$set(this.fotoPendukung, 'fotoBarangPendukung', file);
            this.browseFile();
        }
    },
    
    watch: {
        'fotoPendukung.fotoBarangPendukung': {
            handler(newVal, oldVal) {
                if (!newVal) return;
                if (newVal === oldVal) return;
                this.$emit('onChange', newVal, this.fotoPendukung.index)
            },
            deep: true,
            immediate: false
        }
    }
}
</script>